import React from 'react';
import DefaultSelect from './DefaultSelect';

export default React.forwardRef((props, ref) => (
  <DefaultSelect innerRef={ref} {...props} />
));



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/DefaultSelect/index.js